import { clsx, colorFor } from '../../components/ui';

export function spaceInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return words
    .slice(0, 3)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export function SpaceIcon({ name, iconUrl, size = 48, active, className }: { name: string; iconUrl: string | null; size?: number; active?: boolean; className?: string }) {
  const radius = active ? '30%' : '50%';
  if (iconUrl) {
    return <img src={iconUrl} alt="" className={clsx('object-cover transition-[border-radius]', className)} style={{ width: size, height: size, borderRadius: radius }} draggable={false} />;
  }
  return (
    <span
      className={clsx('flex items-center justify-center font-semibold text-white transition-[border-radius] select-none', className)}
      style={{ width: size, height: size, borderRadius: radius, background: colorFor(name), fontSize: size * 0.32 }}
      aria-hidden
    >
      {spaceInitials(name)}
    </span>
  );
}
